// Sound URLs from myinstants.com
export const SOUNDS = {
  // Market Open - FAAH sound
  MARKET_OPEN: 'https://www.myinstants.com/media/sounds/faah.mp3',
  
  // Market Close - Undertaker Gong
  MARKET_CLOSE: 'https://www.myinstants.com/media/sounds/undertakers-bell.mp3',
  
  // Urgent Alert - 999 Social Credit Siren
  URGENT_ALERT: 'https://www.myinstants.com/media/sounds/999-social-credit-siren.mp3'
};

// Sound Manager class for playing sounds
class SoundManager {
  constructor() {
    this.sounds = {};
    this.enabled = true;
    this.volume = 0.7;
    
    // Load saved preferences
    if (typeof window !== 'undefined') {
      const savedEnabled = localStorage.getItem('ofs_sounds_enabled');
      const savedVolume = localStorage.getItem('ofs_sounds_volume');
      
      if (savedEnabled !== null) {
        this.enabled = savedEnabled === 'true';
      }
      if (savedVolume !== null) {
        this.volume = parseFloat(savedVolume);
      }
    }
  }
  
  // Preload a sound
  preload(name, url) {
    if (typeof window === 'undefined') return;
    
    const audio = new Audio(url);
    audio.preload = 'auto';
    audio.volume = this.volume;
    this.sounds[name] = audio;
  }
  
  // Play a sound by name
  play(name) {
    if (!this.enabled) return;
    
    const sound = this.sounds[name];
    if (sound) {
      sound.currentTime = 0;
      sound.volume = this.volume;
      sound.play().catch(e => console.log('Sound play failed:', e));
    }
  }
  
  // Play market open sound
  playMarketOpen() {
    this.play('marketOpen');
  }
  
  // Play market close sound
  playMarketClose() {
    this.play('marketClose');
  }
  
  // Play urgent alert sound
  playUrgentAlert() {
    this.play('urgentAlert');
  }
  
  // Set enabled state
  setEnabled(enabled) {
    this.enabled = enabled;
    if (typeof window !== 'undefined') {
      localStorage.setItem('ofs_sounds_enabled', String(enabled));
    }
  }
  
  // Set volume (0-1)
  setVolume(volume) {
    this.volume = Math.max(0, Math.min(1, volume));
    if (typeof window !== 'undefined') {
      localStorage.setItem('ofs_sounds_volume', String(this.volume));
    }
    
    // Update all loaded sounds
    Object.values(this.sounds).forEach(audio => {
      audio.volume = this.volume;
    });
  }
  
  // Get current state
  isEnabled() {
    return this.enabled;
  }
  
  getVolume() {
    return this.volume;
  }
}

// Create singleton instance
const soundManager = new SoundManager();

// Preload all sounds
if (typeof window !== 'undefined') {
  soundManager.preload('marketOpen', SOUNDS.MARKET_OPEN);
  soundManager.preload('marketClose', SOUNDS.MARKET_CLOSE);
  soundManager.preload('urgentAlert', SOUNDS.URGENT_ALERT);
}

export default soundManager;
